import { Navigate } from 'react-router-dom';
import { IRoute, PORTAL_URL, PageType, PortalRoutePath } from '@models';
import { Tr } from '@utils';
import { Permission } from '@services';
import { PortalLayout } from '@components/portal/common';
import { OrganizationsIcon, CarListBandIcon } from '@components/icons';
import { Welcome } from './Welcome';
import { DASHBOARD_ROUTES } from './Dashboard';
import { CarListBands } from './CarListBands';
import { LOCATION_ROUTES } from './Location';
import { ORGANIZATION_ROUTES } from './Organizations';
import { ClientAccounts } from './ClientAccounts';
import { COLLABORATORS_ROUTES } from './Collaborators';
import { STOCK_ROUTES } from './Stock';
import { PACKAGE_DEALS_ROUTES } from './PackageDeals';
import { VEHICLE_LIST_ROUTES } from './VehicleList';
import { CONVERSION_LIST_ROUTES } from './ConversionList';
import { WIZARD_ROUTES } from './Wizard';
import { PRODUCT_ROUTES } from './Product';
import { EasyInput } from './EasyInput';
import { QUOTATION_ROUTES } from './Quotation';
import { Configuration } from './Configuration';
import { Help } from './Help';
import { DAILYTASKS_ROUTES } from './DailyTasks';
import { CAR_MODEL_ROUTES } from './CarModels';

export const PORTAL_ROUTES: IRoute = {
	path: `/${PORTAL_URL}`,
	element: <PortalLayout />,
	children: [
		{
			path: PortalRoutePath.WELCOME,
			hideFromMenu: true,
			element: <Welcome />
		},
		{
			path: PortalRoutePath.EASY_INPUT,
			hideFromMenu: true,
			pageType: PageType.FULLSCREEN,
			element: <EasyInput />
		},
		{
			path: PortalRoutePath.CONFIGURATION,
			hideFromMenu: true,
			element: <Configuration />
		},
		{
			path: PortalRoutePath.HELP,
			hideFromMenu: true,
			element: <Help />
		},
		DASHBOARD_ROUTES,
		ORGANIZATION_ROUTES,
		CAR_MODEL_ROUTES,
		{
			path: PortalRoutePath.CLIENT_ACCOUNTS,
			icon: <OrganizationsIcon />,
			text: <Tr.Portal path="client-account.title" />,
			element: <ClientAccounts />,
			canActivate: (_route, user) => !!user?.hasPermission([Permission.READ_ORG, Permission.CREATE_ORG, Permission.DELETE_ORG])
		},
		STOCK_ROUTES,
		PACKAGE_DEALS_ROUTES,
		{
			path: PortalRoutePath.CAR_LIST_BANDS,
			icon: <CarListBandIcon />,
			text: <Tr.Portal path="car-list-bands.title" />,
			element: <CarListBands />,
			canActivate: (_route, user) =>
				!!user?.hasPermission([Permission.CAR_LIST_BAND_READ, Permission.CAR_LIST_BAND_WRITE]) && !user?.isDriver()
		},
		LOCATION_ROUTES,
		QUOTATION_ROUTES,
		COLLABORATORS_ROUTES,
		PRODUCT_ROUTES,
		VEHICLE_LIST_ROUTES,
		CONVERSION_LIST_ROUTES,
		WIZARD_ROUTES,
		DAILYTASKS_ROUTES,
		{
			index: true,
			path: '*',
			hideFromMenu: true,
			element: <Navigate to={{ pathname: PortalRoutePath.WELCOME }} replace />
		}
	]
};
